import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, ViewChild, ElementRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DragulaOptions, DragulaService } from 'ng2-dragula';
import { DashboardChartTypes } from '../core/enums/DashboardChartTypes';
import { IDashboard } from '../core/interfaces/IDashboard';
import { DashboardService } from '../core/services/DashboardService';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WelcomeComponent implements OnInit, OnDestroy {

  @ViewChild('chartsContainer') chartsContainer: ElementRef<HTMLElement>;

  public isCustomizeModeEnable = false;
  public dashboardView = [];
  public modalView = [];
  public readonly dashboardChartTypes = DashboardChartTypes;
  public readonly dashboard = inject(ActivatedRoute).snapshot.data['dashboard'] as IDashboard;

  private readonly _dashboardService = inject(DashboardService);
  private readonly _dragulaService = inject(DragulaService);

  public ngOnInit(): void {
    this.dashboard.dashboard.forEach(x => x.isVisible = x.isVisible ?? true);
    this.dragulaCreateGroup();
    this.listenOnDrop();
  }

  public customizeModeChange(isCustomizeModeEnable: boolean): void {
    this.isCustomizeModeEnable = isCustomizeModeEnable;

    if (!this.isCustomizeModeEnable) {
      const chartsWrappers = this.chartsContainer.nativeElement
        .querySelectorAll('app-chart-wrapper');

      chartsWrappers
        .forEach(
          (x, index) =>
            this.dashboard.dashboard.find(y => y.key.toString() === x.id).order = index + 1
        );

      this._dashboardService.saveDashboard(this.dashboard.dashboard).subscribe();
    }
  }

  public toggleCustomizeMode(): void {
    this.isCustomizeModeEnable = !this.isCustomizeModeEnable;
    this.customizeModeChange(this.isCustomizeModeEnable);
  }

  public get someWidgetsVisible(): boolean {
    return this.dashboard.dashboard.some(x => x.isVisible);
  }

  public get everyWidgetVisible(): boolean {
    return this.dashboard.dashboard.every(x => x.isVisible);
  }

  private dragulaCreateGroup(): void {
    this._dragulaService.createGroup('dashboard', {
      moves: (el, container, handle) => !!handle.closest('app-chart-wrapper')
    } as DragulaOptions);
  }

  private listenOnDrop(): void {
    this._dragulaService.drop('dashboard').subscribe(({ el, target }) => {
      this.dashboard.dashboard.find(x => x.key.toString() === el.id).isVisible =
        !!target.classList.contains('charts-container');
    });
  }

  public ngOnDestroy(): void {
    this._dragulaService.destroy('dashboard');
  }
}
